import { chapBi, DieuKhoanTranInput } from "../helpers/dieuKhoanTran";

interface Props {
  tran: DieuKhoanTranInput & {
    challenger?: { name?: string } | null;
    acceptor?: { name?: string } | null;
  };
  /** Lớp chữ của màn đang gọi, để dòng này trông giống hệt dòng chấp ván bên trên. */
  className?: string;
}

/**
 * Dòng "A chấp B n bi", in cạnh dòng chấp ván.
 *
 * KHÔNG in gì khi không có chấp bi, và đó là trường hợp thường gặp: ma trận v1.0 để
 * chấp bi bằng 0 ở mọi ô, còn trận quyết trước khi có ma trận thì không có trường
 * này. Màn giống hệt hôm nay cho tới khi có người điền chấp bi vào bảng.
 *
 * Chỉ một thành phần cho cả ba màn, nhưng chỉ phần NÀY dùng chung — phần chấp ván vẫn
 * nằm nguyên ở từng màn, nên không màn nào đổi bố cục vì màn khác.
 */
export default function DieuKhoanChap({ tran, className }: Props) {
  const bi = chapBi(tran);
  if (!bi) return null;

  const ten = (ghe: "challenger" | "acceptor") =>
    (ghe === "challenger" ? tran.challenger?.name : tran.acceptor?.name) ?? "";

  return (
    <p className={className ?? "text-[#FFCA16] font-exo text-sm font-medium"}>
      <span className="text-[#C13A28]">{ten(bi.nguoiChap)}</span> chấp{" "}
      <span className="text-[#C13A28]">{ten(bi.nguoiDuocChap)}</span> {bi.soLuong} bi
    </p>
  );
}
